<div
  class="col-12 shadow-1 fadein animation-duration-300"
  [ngClass]="containerType"
>
  <div
    class="flex flex-wrap box-section"
    *ngIf="
      locationFilter ||
      productFilter.show ||
      customerFilter.show ||
      userFilter ||
      dateRequired
    "
  >
    <div *ngIf="locationFilter" class="flex-1 m-2 px-2 py-3">
      <boma-location-search
        (locationSelectedChange)="
          checkSearchParamsUpdated(
            currentLocationsSelected,
            $event,
            locationSelected
          )
        "
        [showLabel]="true"
        [multipleLocations]="!singleLocation"
      ></boma-location-search>
    </div>

    <div
      *ngIf="productFilter.show && this.selectedOrganisation"
      class="flex-1 m-2 px-5 py-3"
    >
      <boma-product-selector
        (selectedProductsChange)="
          checkSearchParamsUpdated(
            currentProductSelected,
            $event,
            productSelected
          )
        "
        [organisation]="this.selectedOrganisation"
        id="productSelect"
        placeHolderText="Select Products"
        [showLabels]="true"
      ></boma-product-selector>
    </div>

    <div *ngIf="customerFilter.show" class="flex-1 m-2 px-2 py-3">
      <boma-customer-selector
        (selectedItemsChange)="
          checkSearchParamsUpdated(
            currentCustomerSelected,
            $event,
            customerSelected
          )
        "
        [initialCustomers]="customerFilter.initialCustomers"
        [singleSelection]="customerFilter.single"
      ></boma-customer-selector>
    </div>

    <div *ngIf="userFilter" class="flex-1 m-2 px-2 py-3">
      <boma-search-entity-users
        (sendSelectedUser)="
          checkSearchParamsUpdated(currentUserSelected, $event, userSelected)
        "
        [entityId]="selectedOrganisation?.id"
        [showLabels]="true"
      >
      </boma-search-entity-users>
    </div>

    <div *ngIf="dateRequired" class="flex-1 m-2 px-2 py-3">
      <boma-location-date-range-selector
        (datesSelected)="datesHandler($event)"
        [changeType]="false"
        [dateRequired]="true"
        [singleDay]="singleDay"
        [selectedDates]="selectedDates"
        [emitDateImmediately]="emitDateOnLoad"
        [locationRequired]="false"
        [shortcutDate]="shortcutDate"
      >
        <!--      TODO EMIT IMMEDIATELY IS CAUSING A RELOAD EVERY TIME -->
      </boma-location-date-range-selector>
    </div>
  </div>
  <!-- Search and filter box -->
  <div
    class="box-section hover-card mb-2"
    *ngIf="
      displaySearchBar ||
      filters ||
      statusFilter ||
      typeFilter ||
      (data?.length && isFileSaverSupported && canExport)
    "
  >
    <!-- FILTER PART 2  -->
    <div class="col-12 pb-0">
      <div class="grid mb-0 pb-0">
        <div class="col" *ngIf="statusFilter && showMultiSelect">
          <span class="p-fluid">
            <boma-checkbox-list
              *ngIf="statusSelector == 'chips'"
              [items]="statusFilter"
              (updateSelection)="handleSelectedSearchParameters($event)"
            ></boma-checkbox-list>

            <p-multiSelect
              *ngIf="statusSelector == 'multiselect'"
              [options]="statusFilter"
              [(ngModel)]="selectedStatuses"
              (onChange)="statusFilterHandler($event)"
              defaultLabel="Any Status"
              optionLabel="label"
              class="mr-3"
              display="chip"
              selectedItemsLabel="{0} statuses"
            ></p-multiSelect>
          </span>
        </div>

        <div class="col" *ngIf="statusFilter && !showMultiSelect">
          <span class="p-fluid">
            <p-dropdown
              (onChange)="statusFilterHandler($event)"
              [(ngModel)]="selectedStatus"
              [options]="statusFilter"
              optionLabel="label"
            ></p-dropdown>
          </span>
        </div>

        <div class="col" *ngIf="filters">
          <span class="p-fluid">
            <p-dropdown
              (onChange)="
                checkSearchParamsUpdated(
                  currentFilterSelected,
                  $event.value,
                  filterSelected
                )
              "
              [(ngModel)]="selectedFilters"
              [options]="filters"
              optionLabel="label"
            ></p-dropdown>
          </span>
        </div>

        <div class="col" *ngIf="typeFilter">
          <span class="p-fluid">
            <p-dropdown
              (onChange)="typeFilterHandler($event)"
              [(ngModel)]="selectedType"
              [options]="typeFilter.options"
              optionLabel="label"
            ></p-dropdown>
          </span>
        </div>

        <div class="col" *ngIf="displaySearchBar || useSearchButton">
          <span class="p-fluid">
            <div class="p-inputgroup">
              <input
                *ngIf="displaySearchBar"
                type="text"
                pInputText
                (input)="searchUpdated($event)"
                [value]="queryParam"
                [(ngModel)]="queryParam"
                [placeholder]="searchBarPlaceHolder"
              />

              <button
                *ngIf="displaySearchBar || useSearchButton"
                type="button"
                [icon]="loaded ? 'pi pi-search' : 'pi pi-spin pi-spinner'"
                (click)="searchNow()"
                pButton
                pRipple
                [label]="loaded ? 'Search' : 'Searching'"
              ></button>
            </div>
          </span>
        </div>
        <!-- <div class="col" *ngIf="false">
          <div class="p-inputgroup">
            <p-dropdown
              (onChange)="perPageUpdated($event)"
              *ngIf="false"
              [(ngModel)]="itemsPerPage"
              [options]="perPageOptions"
              class="ml-auto ml-3"
              placeholder="Entries Per Page"
            ></p-dropdown>
          </div>
        </div> -->
      </div>
    </div>
  </div>

  <p-table
    #dt
    (onLazyLoad)="lazyUpdate($event)"
    [(selection)]="selectedRows"
    [autoLayout]="true"
    [columns]="selectedColumns"
    [lazyLoadOnInit]="false"
    [lazy]="true"
    [(first)]="firstIndex"
    [paginator]="
      !!paginationData?.totalItems ||
      !!paginationData?.previousPage ||
      !!paginationData?.nextPage
    "
    [reorderableColumns]="false"
    [resizableColumns]="false"
    [rows]="itemsPerPage"
    [showCurrentPageReport]="true"
    [totalRecords]="paginationData?.totalItems"
    [value]="data"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} {{
      headersValue
    }}"
    [rowHover]="true"
    loadingIcon="custom-boma-icon"
    responsiveLayout="stack"
    [breakpoint]="'960px'"
    selectionMode="multiple"
    styleClass="p-datatable-striped"
    id="print-content"
  >
    <!-- [scrollable]="true"
  scrollHeight="60vh" -->
    <!--  [stateKey]='(singularTerm || headersValue)+"-local"'-->
    <!--  stateStorage='local'-->

    <ng-template pTemplate="caption">
      <!-- <boma-pagination
        *ngIf="results"
        [results]="results"
        (refreshPage)="refreshEvents()"
        (updatePage)="loadEvents($event)"
      ></boma-pagination> -->

      <!-- <div class="text-center">
        <small>{{ paginationData?.totalItems }} records found</small>
      </div> -->

      <div class="flex justify-content-between">
        <button
          *ngIf="createFormTemplateReference && !createFormRoute"
          (click)="toggleCreateView()"
          class="p-button-success mr-1"
          icon="pi pi-plus"
          label="Add {{ singularTerm }}"
          pButton
          pRipple
        ></button>

        <button
          *ngIf="createFormRoute && !createFormTemplateReference"
          [routerLink]="createFormRoute"
          class="p-button-success mr-1"
          icon="pi pi-plus"
          label="Add {{ singularTerm }}"
          pButton
          pRipple
        ></button>

        <ng-container *ngFor="let action of customTableActions">
          <button
            (click)="this.customTableAction.emit({ action: action })"
            *ngIf="!action.position"
            [class]="'p-button ' + action.class"
            [icon]="action.icon"
            [label]="action.label"
            pButton
            pRipple
          ></button>
        </ng-container>

        <ng-container *ngIf="isFileSaverSupported && canExport">
          <button
            (click)="exportDocument()"
            class="p-button-success ml-2"
            icon="pi pi-file-excel"
            label="Excel"
            pButton
            pRipple
            pTooltip="This feature is in beta, only the results displayed on screen will be exported."
            tooltipPosition="bottom"
            type="button"
          ></button>
        </ng-container>

        <p-multiSelect
          *ngIf="selectableColumns?.length"
          [(ngModel)]="selectedColumns"
          [options]="selectableColumns"
          defaultLabel="Update Columns"
          optionLabel="header"
          selectedItemsLabel="{0} columns selected"
          class="ml-auto"
        ></p-multiSelect>
      </div>
    </ng-template>

    <ng-template let-columns pTemplate="header">
      <tr>
        <th class="text-center" style="width: 3rem">#</th>
        <ng-container *ngFor="let col of columns">
          <!-- TODO Build filtering into the table headers -->

          <th
            *ngIf="col.sortable"
            [style]="col?.style"
            pSortableColumn="{{ col.field }}"
          >
            <div class="flex justify-content-between align-items-center">
              {{ col.header }}
              <p-sortIcon
                field="{{ col.field }}"
                pTooltip="Sort Ascending/Descending"
                tooltipPosition="bottom"
              ></p-sortIcon>
            </div>
          </th>

          <th *ngIf="col.filter?.type === 'select'" [style]="col?.style">
            <div class="flex justify-content-between align-items-center">
              {{ col.header }}
              <p-columnFilter
                [showAddButton]="false"
                [showMatchModes]="false"
                [showOperator]="false"
                display="menu"
                field="representative"
                matchMode="in"
              >
                <ng-template pTemplate="header">
                  <div class="px-3 pt-3 pb-0">
                    <span class="font-bold">Filters</span>
                  </div>
                </ng-template>
                <ng-template
                  let-filter="filterCallback"
                  let-value
                  pTemplate="filter"
                >
                  <p-multiSelect
                    (onChange)="filter($event.value)"
                    [ngModel]="value"
                    [options]="col.filter?.options"
                    optionLabel="name"
                    placeholder="All"
                  >
                    <ng-template let-option pTemplate="item">
                      <div class="p-multiselect-option">
                        <span class="ml-1">{{ option.label }}</span>
                      </div>
                    </ng-template>
                  </p-multiSelect>
                </ng-template>
              </p-columnFilter>
            </div>
          </th>
          <th *ngIf="!col.filter && !col.sortable" [style]="col?.style">
            <div
              [ngClass]="col.type === 'currency' || col.type === 'number' ? 'text-right' : ''"
            >
              <span *ngIf="col.icon" class="overview-icon mr-2">
                <i class="material-icons-round {{ col.icon }}"></i>
              </span>
              {{ col.header }}
            </div>
          </th>
        </ng-container>

        <th
          *ngIf="
            updateFormTemplateReference ||
            allowDelete ||
            viewable ||
            customActions ||
            customActionTemplate
          "
          [style]="col?.style"
        ></th>
      </tr>
    </ng-template>
    <ng-template
      let-columns="columns"
      let-index="rowIndex"
      let-rowData
      pTemplate="body"
    >
      <tr
        [class]="canExport === true ? 'clickable' : 'not-clickable'"
        [pSelectableRow]="canExport === true ? rowData : false"
      >
        <td class="text-right">
          <span class="p-column-title">#</span>{{ index + 1 }}
        </td>
        <td
          *ngFor="let col of columns"
          [class]="(col?.type || 'none').toLowerCase()"
          [style]="col?.style"
          [pTooltip]="col?.tooltip"
          tooltipPosition="top"
        >
          <span class="p-column-title">{{ col.header }}</span>
          <ng-container
            *ngIf="col.field === 'charges' && col.header !== 'Total'"
          >
            <ng-container *ngIf="col.header === 'Charges'">
              <div class="grid justify-content-center">
                <ng-container *ngFor="let charge of rowData[col.field]">
                  <div class="col-12 md:col-4">{{ charge.type }},</div>
                  <div class="col-12 md:col-4">{{ charge.status }},</div>
                  <div class="col-12 md:col-4 c">
                    {{ charge.total | number: '.2-2' }}
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="col.type === 'boolean'">
            <p class="text-center">
              <span
                [ngClass]="{
                  'text-success': rowData[col.field] === true,
                  'text-red-400': rowData[col.field] === false
                }"
                class="material-icons-outlined icon-span"
              >
                {{ rowData[col.field] === true ? 'check_circle' : 'clear' }}
              </span>
            </p>
          </ng-container>
          <ng-container *ngIf="col.type === 'supplierLogistics'">
            <span>
              <p class="m-0">
                {{
                  rowData[col?.field]?.supplyingLocationDetails?.location
                    ?.name || '--'
                }}
              </p>

              <ng-container *ngIf="col.converter(rowData) as item">
                <small class="m-0">
                  <strong>{{ item?.Vehicle }}</strong>

                  <ng-container *ngIf="item?.Driver || item?.Contact">
                    <br />{{ item?.Driver }}
                    {{ item?.Contact }}
                  </ng-container>
                </small>
              </ng-container>
            </span>
          </ng-container>
          <ng-container *ngIf="col.type === 'entityLocation'">
            <span>
              <p class="m-0">
                {{
                  col.converter
                    ? col.converter(rowData[col?.field])
                    : rowData[col?.field]
                }}
              </p>
              <small class="text-left">
                <strong
                  *ngIf="
                    rowData?.locationDetails?.receivingLocationDetails?.location
                      ?.name
                  "
                  >{{
                    rowData?.locationDetails?.receivingLocationDetails?.location
                      ?.name
                  }}<br
                /></strong>

                <ng-container
                  *ngIf="
                    rowData?.locationDetails?.receivingLocationDetails?.location
                      ?.address?.town
                  "
                  >{{
                    rowData?.locationDetails?.receivingLocationDetails?.location
                      ?.address?.town
                  }}</ng-container
                >
                <ng-container
                  *ngIf="
                    rowData?.locationDetails?.receivingLocationDetails?.location
                      ?.address?.province
                  "
                  >,{{
                    rowData?.locationDetails?.receivingLocationDetails?.location
                      ?.address?.province
                  }}</ng-container
                >
              </small>
            </span>
          </ng-container>
          <ng-container *ngIf="col.type === 'rowData'">
            {{ col.converter(rowData) }}
          </ng-container>
          <ng-container *ngIf="col.type === 'user'">
            <span>
              <p class="m-0">
                {{
                  col.converter
                    ? col.converter(rowData[col?.field])
                    : rowData[col?.field]
                }}
              </p>
              <small class="text-center">
                {{ rowData?.originIsSupplier ? '(Internal)' : '(Customer)' }}
              </small>
            </span>
          </ng-container>
          <ng-container *ngIf="col.type === 'decimal' || col.type === 'number'">
            <p class="text-right">
              <span *ngIf="col?.prepend">
                {{ col.prepend }}
              </span>
              {{
                col.converter
                  ? (col.converter(rowData[col.field])
                    | number: (col.type === 'decimal' ? '.2-2' : '.0-0'))
                  : (rowData[col.field]
                    | number: (col.type === 'decimal' ? '.2-2' : '.0-0'))
              }}
              <span *ngIf="col?.append">
                {{ col.append }}
              </span>
            </p>
          </ng-container>
          <ng-container
            *ngIf="col.type === 'currency' && col.header !== 'Charges'"
          >
            <!-- TODO STRIP SPACES out of the value... -->
            <p class="text-right">
              {{ rowData['currencySymbol']
              }}{{
                col.converter
                  ? (col.converter(rowData[col.field]) | number: '.2-2')
                  : (rowData[col.field] | number: '.2-2')
              }}
            </p>
          </ng-container>

          <ng-container *ngIf="col.type === 'dateTime'">
            {{ col.converter(rowData) }}
          </ng-container>

          <ng-container *ngIf="col.type === 'chip'">
            <p-chip
              [styleClass]="
                (col.converter
                  ? col.converter(rowData[col.field])
                  : rowData[col.field]) + '-chip w-100 mr-2 px-3 py-2'
              "
            >
              {{
                col.converter
                  ? col.converter(rowData[col.field])
                  : rowData[col.field]
              }}
              <!-- {{ rowData | json }} -->
              <!-- for icon displaying the handshake instead of a column -->
              <i
                *ngIf="rowData?.deliveryHandshake?.acceptedBy?.firstName"
                class="material-icons-round mi-handshake status-shake"
                [pTooltip]="
                  'Handshake Accepted by ' +
                  rowData.deliveryHandshake?.acceptedBy.firstName +
                  ' ' +
                  rowData.deliveryHandshake?.acceptedBy.surname +
                  ' Delivered by ' +
                  rowData.deliveryHandshake?.deliveredBy.firstName +
                  ' ' +
                  rowData.deliveryHandshake?.deliveredBy.surname
                "
                tooltipPosition="top"
              ></i>
            </p-chip>
          </ng-container>

          <ng-container *ngIf="col.type === 'image'">
            <div
              [style]="
                'background-image:url(' +
                (col.converter
                  ? (col.converter(rowData[col.field])
                    | getFirstAvailableImageForSize: col.size || '60')
                  : (rowData[col.field]
                    | getFirstAvailableImageForSize: col.size || '60')) +
                '); width:' +
                col.size +
                'px; height:' +
                col.size +
                'px;'
              "
              class="rounded-thumbnail image {{
                singularTerm | lowercase
              }}-image"
            ></div>
          </ng-container>

          <ng-container *ngIf="col.type === 'Date'">
            {{
              col.converter
                ? (col.converter(rowData[col.field])
                  | date: 'dd/MM/yyyy, HH:mm:ss')
                : (rowData[col.field] | date: 'dd/MM/yyyy, HH:mm:ss')
            }}
          </ng-container>

          <ng-container *ngIf="col.type === 'Products'">
            <div
              *ngFor="let product of rowData[col.field]"
              class="flex align-items-center justify-content-between py-2"
              [ngClass]="{ 'bm-border-bottom': rowData[col.field].length > 1 }"
            >
              <span>{{ product.product.name }}</span>
              <span class="ml-3"> {{ product.units | number }}</span>
            </div>
          </ng-container>

          <ng-container *ngIf="col.type === 'object'">
            <p
              *ngFor="let item of col.converter(rowData) | keyvalue"
              class="my-1"
            >
              {{ item.value }}
            </p>
          </ng-container>

          <ng-container *ngIf="col.type === 'location'">
            <div *ngIf="!col.converter(rowData)?.name">Collected at POS</div>
            <div
              class="flex justify-content-between align-items-center"
              *ngIf="col.converter(rowData)?.name"
            >
              {{ col.converter(rowData)?.name }}<br />
              <ng-container
                *ngIf="
                  col.converter(rowData)?.address?.line3;
                  else noFormattedAddress
                "
              >
                {{ col.converter(rowData)?.address?.line3 }}
              </ng-container>

              <ng-template #noFormattedAddress>
                ({{ (col.converter(rowData)?.point?.coordinates)[0] }} ,
                {{ (col.converter(rowData)?.point?.coordinates)[1] }})
                <i
                  (click)="openMap(col.converter(rowData))"
                  class="material-icons-round mi-pin-drop cursor-pointer"
                  pTooltip="View Map"
                  tooltipPosition="top"
                ></i>
              </ng-template>
            </div>
          </ng-container>

          <ng-container *ngIf="col.type === 'icons'">
            <span
              *ngFor="let item of col.converter(rowData) | keyvalue"
              class="overview-icon mr-2"
            >
              <i
                class="material-icons-round {{ item?.value?.icon }}"
                pTooltip="{{ item?.value?.label }}"
                tooltipPosition="top"
              ></i>
            </span>
          </ng-container>

          <ng-container *ngIf="col.type == 'fullobject'">
            {{ col.converter(rowData) }}
          </ng-container>

          <ng-container *ngIf="!col.type">
            <div
              [innerHTML]="
                col.converter
                  ? col.converter(rowData[col?.field])
                  : rowData[col?.field]
              "
            ></div>
          </ng-container>
        </td>

        <td
          *ngIf="
            updateFormTemplateReference ||
            allowDelete ||
            viewable ||
            customActions ||
            customActionTemplate
          "
          class="text-right"
        >
          <span></span>
          <span>
            <ng-container *ngIf="viewPath">
              <a
                *ngIf="viewable"
                [href]="viewPath + rowData.id"
                [routerLink]="viewPath + rowData.id"
                class="p-button-rounded p-button-primary mr-2"
                icon="pi pi-eye"
                pButton
                pRipple
                pTooltip="Middle Mouse Button to Open New Window"
                tooltipPosition="left"
                showDelay="600"
              ></a>
            </ng-container>

            <ng-container
              *ngTemplateOutlet="
                customActionTemplate;
                context: { $implicit: rowData }
              "
            >
            </ng-container>

            <!-- TODO ADD A WAY TO HIDE THIS BUTTON EVEN IF  updateFormTemplateReference EXISTS -->
            <button
              (click)="handleItemUpdateSelection(rowData)"
              *ngIf="updateFormTemplateReference"
              class="p-button-rounded p-button-success mr-2"
              icon="pi pi-pencil"
              pButton
              pRipple
              pTooltip="Edit"
              tooltipPosition="top"
            ></button>
            <ng-container *ngIf="!viewPath">
              <button
                (click)="handleItemView(rowData, true)"
                *ngIf="viewable"
                class="p-button-rounded p-button-primary mr-2"
                icon="pi pi-search"
                pButton
                pRipple
                pTooltip="View"
                tooltipPosition="top"
              ></button>
            </ng-container>

            <ng-container *ngFor="let action of customActions">
              <ng-container *ngIf="action?.actionURL">
                <!--            this is to enable us to open multiple tabs instead of forcing a reroute-->
                <a
                  [class]="'p-button-rounded mr-2 ' + action?.style"
                  [href]="action.actionURL + rowData.id"
                  [icon]="action.icon"
                  [pTooltip]="action?.toolTip"
                  [routerLink]="
                    action.actionURL + rowData.id + '/' + action?.parameter
                  "
                  pButton
                  pRipple
                  tooltipPosition="top"
                ></a>
              </ng-container>
              <ng-container *ngIf="!action?.actionURL">
                <button
                  (click)="
                    this.customAction.emit({ action: action, data: rowData })
                  "
                  [class]="'p-button-rounded mr-2 ' + action?.style"
                  [icon]="action.icon"
                  [pTooltip]="action?.toolTip"
                  pButton
                  pRipple
                  tooltipPosition="top"
                ></button>
              </ng-container>
            </ng-container>

            <button
              (click)="deleteItem(rowData)"
              *ngIf="allowDelete"
              class="p-button-rounded p-button-warning"
              icon="pi pi-trash"
              pButton
              pRipple
            ></button>
          </span>
        </td>
      </tr>
    </ng-template>

    <ng-template let-columns pTemplate="emptymessage">
      <ng-container *ngIf="!loaded; else emptyState">
        <tr>
          <td [attr.colspan]="columns?.length + 2" class="text-center">
            <boma-progress-spinner [showLogo]="false"></boma-progress-spinner>
            <h5>Loading...</h5>
          </td>
        </tr>
      </ng-container>

      <ng-template #emptyState>
        <ng-container *ngIf="updatedSearchParams; else emptyResults">
          <tr>
            <td [attr.colspan]="columns?.length + 2" class="text-center">
              <button
                (click)="searchNow()"
                class="p-button p-button-primary mt-2"
                icon="pi pi-search"
                label="Search"
                pButton
                pRipple
              ></button>
            </td>
          </tr>
        </ng-container>

        <ng-template #emptyResults>
          <tr>
            <td [attr.colspan]="columns?.length + 2" class="text-center">
              <h5>No records were found</h5>
              <h5>Please adjust your filters, and try again.</h5>
            </td>
          </tr>
        </ng-template>
      </ng-template>
    </ng-template>
  </p-table>

  <div class="col-12 text-center">
    <button
      (click)="loadNextPage()"
      *ngIf="data?.length && nextPage && !paginationData"
      [icon]="loaded ? 'pi pi-angle-down' : 'pi pi-spin pi-spinner'"
      [label]="loaded ? 'Load More' : 'Loading'"
      class="mt-3"
      pButton
      type="button"
    ></button>
  </div>
</div>

<!-- Create Dialog -->
<p-dialog
  [(visible)]="displayCreateDialog"
  [modal]="true"
  [style]="createFormTemplateReferenceStyle"
>
  <ng-template pTemplate="header">
    <span class="text-xl font-bold"
      >Add {{ singularTerm || headersValue }}</span
    >
  </ng-template>

  <ng-container *ngTemplateOutlet="createFormTemplateReference"> </ng-container>

  <ng-template pTemplate="footer">
    <button
      (click)="hideModal('cancel')"
      class="p-button-text p-button-danger"
      icon="pi pi-times"
      label="Cancel"
      pButton
      pRipple
    ></button>
    <button
      (click)="createItem()"
      [disabled]="!createFormValid"
      class="p-button-text"
      icon="pi pi-check"
      label="Save"
      pButton
      pRipple
    ></button>
  </ng-template>
</p-dialog>

<!-- Update Dialog -->
<p-dialog
  [(visible)]="displayUpdateDialog"
  [modal]="true"
  [style]="{ width: '450px' }"
>
  <ng-template pTemplate="header">
    <span class="text-xl font-bold"
      >Update {{ singularTerm || header.default }}</span
    >
  </ng-template>

  <ng-container *ngTemplateOutlet="updateFormTemplateReference"></ng-container>

  <ng-template pTemplate="footer">
    <button
      (click)="hideModal('cancel')"
      class="p-button-text"
      icon="pi pi-times"
      label="Cancel"
      pButton
      pRipple
    ></button>
    <button
      (click)="updateItem()"
      class="p-button-text"
      icon="pi pi-check"
      label="Save"
      pButton
      pRipple
    ></button>
  </ng-template>
</p-dialog>

<p-confirmDialog [key]="key" #cd [style]="{ width: '450px' }">
  <p-footer>
    <button
      (click)="cd.reject()"
      icon="pi pi-times"
      label="No"
      pButton
      type="button"
    ></button>
    <button
      (click)="cd.accept()"
      icon="pi pi-check"
      label="Yes"
      pButton
      type="button"
    ></button>
  </p-footer>
</p-confirmDialog>

<!-- view dialog -->
<p-dialog
  [(visible)]="displayViewDialog"
  [header]="viewFormTemplateHeading"
  [modal]="true"
  [style]="modalSize"
  (onHide)="hideModal($event)"
>
  <ng-container *ngTemplateOutlet="viewFormTemplateReference"></ng-container>
</p-dialog>

<p-dialog
  [(visible)]="displayMapDialog"
  [header]="selectedPoint?.name || 'Map View'"
  [modal]="true"
  [style]="{ width: '450px' }"
>
  <ng-template pTemplate="content">
    <boma-location-picker-map
      *ngIf="selectedPoint"
      [enableSearch]="false"
      [enableSelection]="false"
      [location]="selectedPoint?.point?.coordinates"
      [zoom]="10"
    >
    </boma-location-picker-map>
  </ng-template>
</p-dialog>
